// Слушатели событий
export const Listeners = {
    // Глобальный прелоадер
    GLOBAL_PRELOADER_SHOW: 'global-preloader-show',
    GLOBAL_PRELOADER_HIDE: 'global-preloader-hide',
    // Прелоадер контента
    CONTENT_PRELOADER_SHOW: 'content-preloader-show',
    CONTENT_PRELOADER_HIDE: 'content-preloader-hide',

    // Глобальный store
    // Данные базы после их загрузки
    GLOBAL_STORE_GET_DATABASE: 'global-store-get-database',
    /**
     * Данные пользователя после их загрузки.
     * Нужно учитывать, что могут возникать ситуации, когда пользователь загрузится до created, mounted компонента.
     * Соответственно, `emit` сработает ранее события `on` и слушатель не сработает.
     */
    GLOBAL_STORE_GET_USER: 'global-store-get-user',

    // Перезагрузка данных пользователя
    REFRESH_USER: 'refresh-user',
    // Popup создания бесплатного проекта
    POPUP_FREE_PROJECT: 'popup-free-project',
    POPUP_FREE_PROJECT_CLOSE: 'popup-free-project-close',
    // Popup DEMO в моих проектах
    POPUP_DEMO_OPEN: 'popup-demo-open',
    POPUP_DEMO_CLOSE: 'popup-demo-close',
    // открытие формы записи для демонстрации
    POPUP_DEMO_BLOCK_OPEN: 'popup-demo-block-open',
    // Popup создания проекта
    POPUP_CREATE_PROJECT: 'popup-create-project',
    POPUP_CREATE_PROJECT_CLOSE: 'popup-create-project-close',
    // Загрузка пользовательских проектов из "Мои проекты"
    LOAD_USER_PROJECTS: 'load-user-projects',
    // Загрузка моих проектов из Сравнения конкурентов по периоду
    LOAD_USER_PROJECTS_COMPETITORS_BY_PERIOD: 'load-user-projects-competitors-by-period',
    // Popup добавления параметров в Сравнение с конкурентами моих проектов
    POPUP_COMPETITORS_ADD_PARAM_SHOW: 'popup-competitors-add-param-show',
    POPUP_COMPETITORS_ADD_PARAM_CLOSE: 'popup-competitors-add-param-close',
    // Переход на отчет сравнения сайтов со сравнения конкурентов моих проектов
    COMPETITORS_ON_CLICK_FULL_REPORT: 'competitors-on-click-full-report',
    // Popup demo в KSTable
    POPUP_KS_TABLE_DEMO_OPEN: 'popup-ks-table-demo-open',
    // Popup подключения telegram-оповещений
    POPUP_TELEGRAM_CONNECT_OPEN: 'popup-telegram-connect-open',
    POPUP_TELEGRAM_CONNECT_CLOSE: 'popup-telegram-connect-close',
    // Пользователь подключил телеграм
    USER_TELEGRAM_CONNECTED: 'user-telegram-connected',
    // Чекбоксы в KSTable
    KS_TABLE_CHECKBOX_SELECTED: 'ks-table-checkbox-selected',
    KS_TABLE_CLEAR_SELECTED_TO: 'ks-table-clear-selected-to',
    KS_TABLE_MAKE_MASTER_KEY: 'ks-table-make-master-key',
    KS_TABLE_NORMALIZE_FIELDS: 'ks-table-normalize-fields',
    KS_TABLE_DO_LOAD: 'ks-table-do-load',
    KS_TABLE_DATA_LOADED: 'ks-table-data-loaded', // Данные таблицы загружены
    // Уведомление об ограничениях функции в демо режиме
    KS_TABLE_SHOW_RESTRICTIONS_DIALOG: 'ks-table-show-restrictions-dialog',
    KS_TABLE_DOWNLOAD: 'ks-table-download',
    KS_TABLE_CSV_EXPORT_PROGRESS: 'ks-table-csv-export-progress',
    KS_TABLE_CSV_EXPORT_FINISHED: 'ks-table-csv-export-finished',
    KS_TABLE_DOWNLOAD_IMAGES: 'ks-table-download-images',
    KS_TABLE_COPY: 'ks-table-copy',
    KS_TABLE_DOMAIN_HISTORY_BY_KEYS: 'ks-table-domain-history-by-keys',
    KS_TABLE_POPUP_DOMAIN_HISTORY_BY_KEYS_OPEN: 'ks-table-popup-domain-history-by-keys-open',
    KS_TABLE_POPUP_DOMAIN_HISTORY_BY_KEYS_CLOSE: 'ks-table-popup-domain-history-by-keys-close',
    // Открытие графика Онлайн - Парсера по WS
    KS_TABLE_POPUP_ONLINE_PARSER_WS: 'ks-table-popup-online-parser-ws',
    KS_TABLE_POPUP_ONLINE_PARSER_WS_OPEN: 'ks-table-popup-online-parser-ws-open',
    // Изменения топа по конкурентам
    KS_TOP_CHANGE: 'ks-top-change',
    // Подтверждение фильтров KSFilter
    KS_FILTER_SUBMIT_FORM: 'ks-filter-submit-form',
    KS_FILTER_SET: 'ks-filter-set',
    KS_FILTER_REFRESH: 'ks-filter-refresh',
    KS_FILTER_CLEAR: 'ks-filter-clear',
    KS_FILTER_SIMPLE_CLEAR: 'ks-filter-simple-clear',
    KS_FILTER_RESET: 'ks-filter-reset',
    KS_DELETE_FILTER_PARAMS: 'ks-delete-filter-params',
    KS_FILTER_SET_FOR_DAY: 'ks-filter-set-for-day',
    KS_FILTER_CONTEXT_SET: 'ks-filter-context-set',
    KS_FILTER_APPLY_SAVED: 'ks-filter-apply-saved',
    // Удаление проекта
    KS_DELETE_PROJECT: 'ks-delete-project',
    KS_DELETE_PROJECT_OPEN: 'ks-delete-project-open',
    KS_DELETE_PROJECT_CLOSE: 'ks-delete-project-close',
    // Подтверждение оплаты с иностранной карты
    KS_STRIPE_AGREEMENT_PAYMENT: 'ks-stripe-agreement-payment',
    // Изменение владельца отчета
    KS_CHANGE_OWNER_REPORT: 'ks-change-owner-report',
    KS_POPUP_CHANGE_OWNER_REPORT_OPEN: 'ks-popup-change-owner-report-open',
    KS_POPUP_CHANGE_OWNER_REPORT_CLOSE: 'ks-popup-change-owner-report-close',
    KS_POPUP_CHANGE_CLUSTER_OWNER_REPORT_OPEN: 'ks-popup-change-cluster-owner-report-open',
    KS_POPUP_CHANGE_CLUSTER_OWNER_REPORT_CLOSE: 'ks-popup-change-cluster-owner-report-close',
    // информация по лимитам загружена
    KS_LIMITS_LOADED: 'ks-limits-loaded',
    // открытие попап информационного описания столбцов KSTable
    KS_POPUP_SHOW_INFO_KSTABLE_COLUMNS: 'ks-popup-show-info-kstable-columns',
    KS_POPUP_CREATE_GROUP_REPORT_OPEN: 'ks-popup-create-group-report-open',
    // открытие попап сохранения фильтра
    KS_POPUP_SAVE_FILTER_OPEN: 'ks-popup-save-filter-open',
    // закрытие попап сохранения фильтра
    KS_POPUP_SAVE_FILTER_CLOSE: 'ks-popup-save-filter-close',
    // открытие попап управления фильтрами
    KS_POPUP_EDIT_FILTERS_OPEN: 'ks-popup-edit-filters-open',
    // Удаление отчета
    KS_DELETE_REPORT: 'ks-delete-report',
    KS_POPUP_DELETE_GROUP_REPORT_OPEN: 'ks-popup-delete-group-report-open',
    KS_POPUP_DELETE_GROUP_REPORT_CLOSE: 'ks-popup-delete-group-report-close',
    CLUSTER_EXPORT_NODE: 'cluster-export-node',
    CLUSTER_POPUP_EXPORT_NODE_OPEN: 'cluster-popup-export-node-open',
    CLUSTER_POPUP_EXPORT_NODE_CLOSE: 'cluster-popup-export-node-close',
    CLUSTER_REFRESH_FILTER: 'cluster-refresh-filter',
    CLUSTER_MOVE_KEYS: 'cluster-move-keys',
    // старт перетягивания ключей в кластеризаторе
    CLUSTER_DRAG_START_KEYS: 'cluster-drag-start-keys',
    CLUSTER_EMPTY_TRASH: 'cluster-empty-trash',
    CLUSTER_MOVE_KEYS_FROM_FILTER: 'cluster-move-keys-from-filter',
    CLUSTER_POPUP_MOVE_KEYS_FROM_FILTER_OPEN: 'cluster-popup-move-keys-from-filter-open',
    CLUSTER_POPUP_MOVE_KEYS_FROM_FILTER_CLOSE: 'cluster-popup-move-keys-from-filter-close',
    CLUSTER_TOUR_START: 'cluster-tour-start',
    CLUSTER_TOUR_SET_NODE: 'cluster-tour-set-node',
    CLUSTER_MOVE_NODE: 'cluster-move-node',
    CLUSTER_MOVE_NODE_DIALOG: 'cluster-move-node-dialog',
    CLUSTER_MOVE_NODE_DIALOG_OPEN: 'cluster-move-node-dialog-open',
    CLUSTER_MOVE_NODE_DIALOG_CLOSE: 'cluster-move-node-dialog-close',
    CLUSTER_CREATE_NODE: 'cluster-create-node',
    CLUSTER_CREATE_NODE_OPEN: 'cluster-create-node-open',
    CLUSTER_CREATE_NODE_CLOSE: 'cluster-create-node-close',
    CLUSTER_CREATE_NODE_FROM_FILTER: 'cluster-create-node-from-filter',
    CLUSTER_POPUP_CREATE_NODE_FROM_FILTER_OPEN: 'cluster-popup-create-node-from-filter-open',
    CLUSTER_POPUP_CREATE_NODE_FROM_FILTER_CLOSE: 'cluster-popup-create-node-from-filter-close',
    CLUSTER_UPDATE_NODE: 'cluster-update-node',
    CLUSTER_DELETE_NODE: 'cluster-delete-node',
    CLUSTER_POPUP_DELETE_NODE_OPEN: 'cluster-popup-delete-node-open',
    CLUSTER_POPUP_DELETE_NODE_CLOSE: 'cluster-popup-delete-node-close',
    CLUSTER_SET_LOCK_NODE: 'cluster-set-lock-node',
    CLUSTER_UNSET_LOCK_NODE: 'cluster-unset-lock-node',
    CLUSTER_TREE_RELOAD: 'cluster-tree-reload',
    CLUSTER_SHOW_COMPONENT: 'cluster-show-component',
    CLUSTER_POPUP_CREATE_OPEN: 'cluster-popup-create-open',
    CLUSTER_POPUP_TREE_FILTER_OPEN: 'cluster-popup-tree-filter-open',
    CLUSTER_POPUP_TREE_FILTER_CLOSE: 'cluster-popup-tree-filter-close',
    CLUSTER_POPUP_SETTING_OPEN: 'cluster-popup-setting-open',
    CLUSTER_POPUP_SETTING_CLOSE: 'cluster-popup-setting-close',
    AUTO_CLUSTER_POPUP_OPEN: 'auto-cluster-popup-open',
    AUTO_CLUSTER_POPUP_CLOSE: 'auto-cluster-popup-close',
    UPDATE_FREQUENCY_POPUP_OPEN: 'update-frequency-popup-open',
    UPDATE_FREQUENCY_POPUP_CLOSE: 'update-frequency-popup-close',
    // открытие попапа с выбором регионов на странице экспорта кампании
    REGION_SHOW_ITEM: "region-show-item",
    // закрытие попапа с выбором регионов на странице экспорта кампании
    REGION_HIDE_ITEM: 'region-hide-item',
    TREE_PAGES_POPUP_SETTING_OPEN: 'tree-pages-popup-setting-open',
    TREE_PAGES_POPUP_SETTING_CLOSE: 'tree-pages-popup-setting-close',
    TREE_PAGES_POPUP_EXPORT_OPEN: 'tree-pages-popup-export-open',
    TREE_PAGES_POPUP_EXPORT_CLOSE: 'tree-pages-popup-export-close',
    POSITIONS_POPUP_CREATE_PROJECT_OPEN: 'positions-popup-create-project-open',
    POSITIONS_POPUP_CREATE_PROJECT_CLOSE: 'positions-popup-create-project-close',

    // Cluster Actions
    CLUSTER_POPUP_IMPORT_FROM_AREA_OPEN: 'cluster-popup-import-from-area-open',
    CLUSTER_POPUP_IMPORT_FROM_FILE_OPEN: 'cluster-popup-import-from-file-open',
    CLUSTER_POPUP_IMPORT_GROUP_REPORT_OPEN: 'cluster-popup-import-group-report-open',
    CLUSTER_POPUP_DELETE_FROM_AREA_OPEN: 'cluster-popup-delete-from-area-open',
    CLUSTER_POPUP_DELETE_FROM_FILE_OPEN: 'cluster-popup-delete-from-file-open',
    CLUSTER_POPUP_DELETE_FROM_FILTER_OPEN: 'cluster-popup-delete-from-filter-open',
    CLUSTER_POPUP_DELETE_FROM_FILTER_GROUP_OPEN: 'cluster-popup-delete-from-filter-group-open',
    CLUSTER_POPUP_DELETE_DOUBLES_OPEN: 'cluster-popup-delete-doubles-open',
    CLUSTER_POPUP_DELETE_FROM_TEMPLATE_OPEN: 'cluster-popup-delete-from-template-open',
    // попап с историей действий
    CLUSTER_POPUP_HISTORY_OPEN: 'cluster-popup-history-open',
    CLUSTER_POPUP_HISTORY_CLOSE: 'cluster-popup-history-close',
    // перезагрузка списка созданных проектов кластеризатора
    CLUSTER_LIST_RELOAD: 'cluster-list-reload',
    // перемещение запросов в другую папку
    CLUSTER_KEYS_MOVE_FOLDER: 'cluster-keys-move-folder',

    // Group Actions
    GROUP_POPUP_IMPORT_FROM_AREA_OPEN: 'group-popup-import-from-area-open',
    GROUP_POPUP_IMPORT_FROM_FILE_OPEN: 'group-popup-import-from-file-open',
    GROUP_POPUP_IMPORT_FROM_DOMAINS_OPEN: 'group-popup-import-from-domains-open',
    GROUP_POPUP_DELETE_FROM_AREA_OPEN: 'group-popup-delete-from-area-open',
    GROUP_POPUP_DELETE_FROM_FILE_OPEN: 'group-popup-delete-from-file-open',
    GROUP_POPUP_DELETE_FROM_DOMAINS_OPEN: 'group-popup-delete-from-domains-open',
    GROUP_POPUP_DELETE_FROM_FILTER_OPEN: 'group-popup-delete-from-filter-open',
    GROUP_POPUP_DELETE_DOUBLES_OPEN: 'group-popup-delete-doubles-open',
    GROUP_POPUP_DELETE_FROM_TEMPLATE_OPEN: 'group-popup-delete-from-template-open',

    // перезагрузка списка групповых отчетов
    RELOAD_GROUP_REPORTS_LIST: 'reload-group-reports-list',
    // загрузка данных группового отчета по хешу + подгрузка дефолтных значений
    LOAD_GROUP_REPORT_DATA_FROM_HASH: 'load-group-report-data-from-hash',
    // очистка фильтра группового отчета
    RESET_FILTER_GROUP_REPORT: 'reset-filter-group-report',

    // Panel
    // вывод popup для корпоративного добавления пользователя
    CORPORATE_POPUP_ADD_USER_OPEN: 'corporate-popup-add-user-open',
    CORPORATE_POPUP_ADD_USER_HIDE: 'corporate-popup-add-user-hide',
    // вывод popup для корпоративного приглашения пользователя
    CORPORATE_POPUP_REBIND_USER_OPEN: 'corporate-popup-rebind-user-open',
    CORPORATE_POPUP_REBIND_USER_HIDE: 'corporate-popup-rebind-user-hide',
    // вывод popup для корпоративного удаления пользователя
    CORPORATE_POPUP_DELETE_USER_OPEN: 'corporate-popup-delete-user-open',
    CORPORATE_POPUP_DELETE_USER_HIDE: 'corporate-popup-delete-user-hide',
    // отображение формы ввода кода на доступ
    PANEL_PROMO_SHOW_ACTIVATE_FORM: 'panel-promo-show-activate-form',

    // table actions
    // выбран чекбокс в таблице (primeVue)
    TABLE_CHECKBOX_SELECTED: 'table-checkbox-selected',
    TABLE_CLEAR_SELECTED: 'table-clear-selected',

    RSYA_POPUP_GROUPING_OPEN: 'rsya-popup-grouping-open',

    // popup создания партнерского промокода
    POPUP_PARTNER_CREATE_PROMO_OPEN: 'popup-partner-create-promo-open',
    POPUP_PARTNER_CREATE_PROMO_CLOSE: 'popup-partner-create-promo-close',

    // projects
    // popup удаления проекта
    PROJECTS_POPUP_DELETE_OPEN: 'projects-popup-delete-open',
    // popup редактирования уведомлений проекта
    PROJECTS_POPUP_NOTIFICATIONS_OPEN: 'projects-popup-notifications-open',
    // popup редактирования конкурентов проекта
    PROJECTS_POPUP_COMPETITORS_EDIT_OPEN: 'projects-popup-competitors-edit-open',

    // wordstat
    // popup создания задания wordstat
    WORDSTAT_POPUP_CREATE_OPEN: 'wordstat-popup-create-open',
    WORDSTAT_POPUP_CREATE_CLOSE: 'wordstat-popup-create-close',
    // перезагрузить список заданий
    WORDSTAT_REFRESH_PROJECTS_LIST: 'wordstat-refresh-projects-list',
    // popup удаления проекта
    WORDSTAT_POPUP_DELETE_PROJECT_OPEN: 'wordstat-popup-delete-project-open',
    WORDSTAT_POPUP_DELETE_PROJECT_SHOW: 'wordstat-popup-delete-project-show',
    WORDSTAT_POPUP_DELETE_PROJECT_CLOSE: 'wordstat-popup-delete-project-close',
    // обновление частотности
    WORDSTAT_POPUP_UPDATE_PROJECT_OPEN: 'wordstat-popup-update-project-open',
    WORDSTAT_POPUP_UPDATE_WORDS_OPEN: 'wordstat-popup-update-words-open',
    // импорт из списка
    WORDSTAT_POPUP_IMPORT_FROM_AREA: 'wordstat-popup-import-from-area',
    // удаление из списка
    WORDSTAT_POPUP_DELETE_FROM_AREA_OPEN: 'wordstat-popup-delete-from-area-open',
    WORDSTAT_POPUP_DELETE_FROM_AREA_CLOSE: 'wordstat-popup-delete-from-area-close',
    // удаление минус-слов
    WORDSTAT_POPUP_DELETE_MINUS_WORDS_OPEN: 'wordstat-popup-delete-minus-words-open',
    WORDSTAT_POPUP_DELETE_MINUS_WORDS_CLOSE: 'wordstat-popup-delete-minus-words-close',

    // перезагрузка данных по подсветке топов
    TOOLS_CHECK_TOP_RELOAD_DATA: 'tools-check-top-reload-data',
    // выбор чекбокса в карточке ключевого слова
    TOOLS_CHECK_TOP_RELOAD_KEYWORD_SELECTED_ITEMS: 'tools-check-top-reload-keyword-selected-items',
    // наведение на строку в карточке ключевого слова
    TOOLS_CHECK_TOP_KEYWORD_HOVERED_ROW_URL: 'tools-check-top-keyword-hovered-row-url',
    // click на строке
    TOOLS_CHECK_TOP_KEYWORD_CLICKED_ROW_URL: 'tools-check-top-keyword-clicked-row-url',
    // очистка выбранных чекбоксов
    TOOLS_CHECK_TOP_CLEAR_KEYWORD_SELECTED_ITEMS: 'tools-check-top-clear-keyword-selected-items',
    TOOLS_CHECK_TOP_CLEAR_DOMAIN_SELECTED_ITEMS: 'tools-check-top-clear-domain-selected-items',
    TOOLS_CHECK_TOP_CLEAR_URL_SELECTED_ITEMS: 'tools-check-top-clear-url-selected-items',

    // показать весь текст в отзывах
    REVIEW_ITEMS_SHOW_FULL_USERS_TEXT: 'review-items-show-full-users-text',

    // проекты Serp
    // перезагрузить список заданий
    SERP_REFRESH_PROJECTS_LIST: 'serp-refresh-projects-list',
    // popup создания задания выдачи
    SERP_POPUP_CREATE_OPEN: 'serp-popup-create-open',
    SERP_POPUP_CREATE_CLOSE: 'serp-popup-create-close',
    // popup постановки проекта на обновление
    SERP_POPUP_TASK_PROJECT_OPEN: 'serp-popup-task-project-open',
    SERP_POPUP_TASK_PROJECT_SHOW: 'serp-popup-task-project-show',
    SERP_POPUP_TASK_PROJECT_CLOSE: 'serp-popup-task-project-close',
    // popup удаления проекта
    SERP_POPUP_DELETE_PROJECT_OPEN: 'serp-popup-delete-project-open',
    SERP_POPUP_DELETE_PROJECT_SHOW: 'serp-popup-delete-project-show',
    SERP_POPUP_DELETE_PROJECT_CLOSE: 'serp-popup-delete-project-close',
    // popup обновления проекта
    SERP_POPUP_UPDATE_PROJECT_OPEN: 'serp-popup-update-project-open',
    // открытие ссылок ИИ ответа
    SERP_POPUP_AI_LINKS_OPEN: 'serp-popup-al-links-open',
    // отчёт: список съёмов и выбранный ({versions, ver}) — для селектора «Дата съёма» в шапке
    SERP_VERSIONS_STATE: 'serp-versions-state',
    // отчёт: выбран съём в селекторе «Дата съёма»
    SERP_VERSION_CHANGE: 'serp-version-change',
    // наведение на строку в карточке ключевого слова
    SERP_KEYWORD_HOVERED_ROW_URL: 'serp-keyword-hovered-row-url',
    // click на строке
    SERP_KEYWORD_CLICKED_ROW_URL: 'serp-keyword-clicked-row-url',
    SERP_CLEAR_DOMAIN_SELECTED_ITEMS: 'serp-clear-domain-selected-items',
    SERP_CLEAR_URL_SELECTED_ITEMS: 'serp-clear-url-selected-items',

    // переименование последнего элемента в хлебных крошках
    BLOCK_BREADCRUMBS_LAST_ITEM_RENAME: 'block-breadcrumbs-last-item-rename',
    // открытие видео - инструкции в хлебных крошках
    BLOCK_BREADCRUMBS_VIDEO_OPEN: 'block-breadcrumbs-video-open',
    // сброс в переданную минимальную высоту уже зафиксированной для адаптера линивого загрузчика
    ADAPTERS_LAZY_LOADER_RESET_MIN_HEIGHT: 'adapters-lazy-loader-reset-min-height',
    // отмена pending unrender (смена layout без размонтирования видимых карточек)
    ADAPTERS_LAZY_LOADER_KEEP_RENDERED: 'adapters-lazy-loader-keep-rendered',
    // плеер (RuTubeEmbed)
    RUTUBE_EMBED_PLAY: 'rutube-embed-play',
    RUTUBE_EMBED_PAUSE: 'rutube-embed-pause',

    /**
     * Проекты мониторинга
     */
    // попап создания проекта
    MONITORING_POPUP_CREATE_OPEN: 'monitoring-popup-create-open',
    MONITORING_POPUP_CREATE_CLOSE: 'monitoring-popup-create-close',
    // попап обновления проекта
    MONITORING_POPUP_UPDATE_OPEN: 'monitoring-popup-update-open',
    MONITORING_POPUP_UPDATE_CLOSE: 'monitoring-popup-update-close',
    // попап удаления проекта
    MONITORING_POPUP_DELETE_OPEN: 'monitoring-popup-delete-open',
    MONITORING_POPUP_DELETE_CLOSE: 'monitoring-popup-delete-close',
    // попап добавления ключевых слов
    MONITORING_POPUP_ADD_WORDS_OPEN: 'monitoring-popup-add-words-open',
    MONITORING_POPUP_ADD_WORDS_CLOSE: 'monitoring-popup-add-words-close',
    // попап удаления ключевого слова
    MONITORING_POPUP_DELETE_WORD_OPEN: 'monitoring-popup-delete-word-open',
    MONITORING_POPUP_DELETE_WORD_CLOSE: 'monitoring-popup-delete-word-close',
    // перезагрузить список проектов
    MONITORING_REFRESH_PROJECTS_LIST: 'monitoring-refresh-projects-list',
    // обновление данных таблицы (изменена сортировка, страница или per_page)
    MONITORING_UPDATE_REPORT_TABLE: 'monitoring-update-report-table',
    // перезагрузка всех данных отчета мониторинга
    MONITORING_REFRESH_DATA: 'monitoring-refresh-data',
    // layout привязки URL
    MONITORING_LAYOUT_UPDATE_URL_OPEN: 'monitoring-layout-update-url-open',
    MONITORING_LAYOUT_UPDATE_MASS_URL_OPEN: 'monitoring-layout-update-mass-url-open',
    // popup графика динамики позиций фразы
    MONITORING_POPUP_WORD_CHART_OPEN: 'monitoring-popup-word-chart-open',
    MONITORING_POPUP_WORD_CHART_CLOSE: 'monitoring-popup-word-chart-close',
    // выгрузка
    MONITORING_EXPORT_FILE: 'monitoring-export-file',
    // обновление массива фраз, без popup
    MONITORING_UPDATE_WORDS: 'monitoring-update-words',
    // проверка статусов проектов
    MONITORING_CHECK_PROJECTS_STATUS: 'monitoring-check-projects-status',
    // проверка статуса одного проекта
    MONITORING_CHECK_PROJECT_STATUS: 'monitoring-check-project-status',
    // проверка статуса кластеризатора
    MONITORING_CHECK_CLUSTER_STATUS: 'monitoring-check-cluster-status',

    // нажатие на кнопку бокового меню в топ меню
    LEFT_MENU_CLICK: 'left-menu-click',
    LEFT_MENU_MOBILE_TOGGLE: 'lef-menu-mobile-toggle',
    /** Закрыть мобильное боковое меню без переключения */
    LEFT_MENU_MOBILE_CLOSE: 'left-menu-mobile-close',
    // настройки
    LEFT_MENU_SETTINGS: 'left-menu-settings',
    // добавление в избранные
    LEFT_MENU_ADD_FAVORITE: 'left-menu-add-favorite',
    // удаление из избранного
    LEFT_MENU_REMOVE_FAVORITE: 'left-menu-remove-favorite',
    // наведение для отображения системных уведомлений
    TOP_MENU_SYSTEM_NOTIFICATIONS_HOVER: 'top-menu-system-notifications-hover',
    // наведение для отображения меню пользователя
    TOP_MENU_TOP_USER_HOVER: 'top-menu-top-user-hover',
    // наведение для отображения помощи
    TOP_MENU_TOP_HELP_HOVER: 'top-menu-top-help-hover',
    // наведение для отображения "Сайты"
    TOP_MENU_TOP_SITES_HOVER: 'top-menu-top-sites-hover',
    // наведение для отображения "Ссылки"
    TOP_MENU_TOP_LINKS_HOVER: 'top-menu-top-links-hover',
    // наведение для отображения "Запросы"
    TOP_MENU_TOP_KEYWORDS_HOVER: 'top-menu-top-keywords-hover',
    // наведение для отображения "Реклама"
    TOP_MENU_TOP_ADS_HOVER: 'top-menu-top-ads-hover',
    // наведение для отображения "Прочее"
    TOP_MENU_TOP_MORE_HOVER: 'top-menu-top-more-hover',
    // наведение для отображения "Прочее" для гостя
    TOP_MENU_TOP_GUEST_MORE_HOVER: 'top-menu-top-guest-more-hover',
    // наведение на дополнительные ссылки "Органика"
    TOP_MENU_ORGANIC_HOVER: 'top-menu-organic-hover',
    // наведение на дополнительные ссылки в групповом отчёте "Органика"
    TOP_MENU_ORGANIC_GROUP_HOVER: 'top-menu-organic-group-hover',
    // наведение на дополнительные ссылки "Ссылки"
    TOP_MENU_LINKS_HOVER: 'top-menu-links-hover',
    // наведение на дополнительные ссылки "Реклама"
    TOP_MENU_CONTEXT_HOVER: 'top-menu-context-hover',
    // наведение на дополнительные ссылки в групповом отчёте "Реклама"
    TOP_MENU_CONTEXT_GROUP_HOVER: 'top-menu-context-group-hover',
    // наведение на дополнительные ссылки "ИИ-ответы"
    TOP_MENU_AI_ANSWERS_HOVER: 'top-menu-ai-answers-hover',
    // обновление высоты блока верхнего меню
    TOP_MENU_UPDATE_HEIGHT: 'top-menu-update-height',

    /**
     * ИИ трекер
     */
    // попап создания проекта
    AI_TRACKER_POPUP_CREATE_OPEN: 'ai-tracker-popup-create-open',
    AI_TRACKER_POPUP_CREATE_CLOSE: 'ai-tracker-popup-create-close',
    // перезагрузка списка проектов
    AI_TRACKER_RELOAD_LIST_PROJECTS: 'ai-tracker-reload-list-projects',
    // попап обновления проекта
    AI_TRACKER_POPUP_UPDATE_OPEN: 'ai-tracker-popup-update-open',
    // попап удаления проекта
    AI_TRACKER_POPUP_DELETE_OPEN: 'ai-tracker-popup-delete-open',
    // перезагрузка сущности отчёта
    AI_TRACKER_REFRESH_ENTITY: 'ai-tracker-refresh-entity',
    // обновление данных отчёта
    AI_TRACKER_REFRESH_DATA: 'ai-tracker-refresh-data',
    // экспорт CSV
    AI_TRACKER_EXPORT_FILE: 'ai-tracker-export-file',
    // обновление данных отчёта по конкурентам
    AI_TRACKER_REFRESH_DATA_COMPETITORS: 'ai-tracker-refresh-data-competitors',
    // попап добавления конкурентов
    AI_TRACKER_POPUP_ADD_COMPETITORS_OPEN: 'ai-tracker-popup-add-competitors-open',
    // попап удаления конкурентов
    AI_TRACKER_POPUP_DELETE_COMPETITORS_OPEN: 'ai-tracker-popup-delete-competitors-open',
    // попап удаления промптов
    AI_TRACKER_POPUP_DELETE_PROMPTS_OPEN: 'ai-tracker-popup-delete-prompts-open',
    // попап удаления групп у промптов
    AI_TRACKER_POPUP_DELETE_PROMPTS_GROUPS_OPEN: 'ai-tracker-popup-delete-prompts-groups-open',
    // попап добавления промптов в группы
    AI_TRACKER_POPUP_ADD_PROMPTS_GROUPS_OPEN: 'ai-tracker-popup-add-prompts-groups-open',
    // очистка выделения чекбоксов в таблице отчёта, конкурентов
    AI_TRACKER_TABLES_SELECTED_CHECKBOX_CLEAR: 'ai-tracker-tables-selected-checkbox-clear',
    // включаем новые группы
    AI_TRACKER_SET_NEW_GROUPS: 'ai-tracker-set-new-groups',
    // наведение на кнопку "Перегенерировать"
    AI_TRACKER_POPUP_REGENERATE_PROMPTS: 'ai-tracker-popup-regenerate-prompts',
    // попап добавления гостевой ссылки
    AI_TRACKER_POPUP_ADD_SHARE_LINK_OPEN: 'ai-tracker-popup-add-share-link-open',
    // перезагрузка данных гостевых ссылок
    AI_TRACKER_REFRESH_SHARE_LINKS: 'ai-tracker-refresh-share-links',
    // открытие попапа упоминаний промпта
    AI_TRACKER_OPEN_PROMPT_MENTIONS: 'ai-tracker-open-prompt-mentions',

    // попап добавления гостевой ссылки мониторинга
    MONITORING_POPUP_ADD_SHARE_LINK_OPEN: 'monitoring-popup-add-share-link-open',
    // перезагрузка данных гостевых ссылок мониторинга
    MONITORING_REFRESH_SHARE_LINKS: 'monitoring-refresh-share-links',

    // попап удаления аккаунта
    PANEL_DELETE_ACCOUNT_POPUP_OPEN: 'panel-delete-account-popup-open',

    // Объявления: месяцы архива и выбранный месяц ({months, month}) — для селектора «Период» в шапке
    ADS_MONTHS_STATE: 'ads-months-state',
    // Объявления: выбран месяц в селекторе «Период» ('' — текущее состояние)
    ADS_MONTH_CHANGE: 'ads-month-change',
};
